import { Tooltip } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';

export const TooltipStyled = withStyles((theme: Theme) => ({
  tooltip: {
    color: theme.palette.text.secondary,
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    boxShadow: theme.shadows[1],
    lineHeight: '1.7',
    maxWidth: '240px',
    verticalAlign: 'middle', // a veces se renderiza dentro de un th
  },
}))(Tooltip);
